import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})

export class LoadingComponent implements OnInit {
  status$ = { active: false, text: '' };
  textDefault = 'Carregando, aguarde um momento...';

  constructor(private load: LoadingService) {
    this.load.load$.subscribe((val: any) => (this.status$ = { ...val } ));
  }

  ngOnInit(): void {}

  teste() {
    this.load.setLoadState({
      active: !this.status$.active,
      text: `Testeando alteração, valor: '${!this.status$.active}'`
    });
  }
}
